import {DownloadIcon} from '@heroicons/react/outline';
import {FC, useEffect, useState} from 'react';
import {TextButton} from './Buttons';

interface CSVDownloadProps {
  headers: string[];
  data: any[][];
  filename: string;
  buttonText?: string;
}

const localDownload = (filename: string, data: string) => {
  let xhr = new XMLHttpRequest();
  xhr.responseType = 'blob';
  xhr.onload = function () {
    const url = window.URL.createObjectURL(xhr.response);

    let a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    a.remove();

    window.URL.revokeObjectURL(url);
  };

  xhr.open('GET', data);
  xhr.send();
};

export const CSVDownload: FC<CSVDownloadProps> = ({headers, data, filename, buttonText = 'Download CSV'}) => {
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleDownload = () => {
    // Convert data to CSV format
    const csvContent = [headers.join(','), ...data.map((row) => row.join(','))].join('\n');

    // Trigger download
    localDownload(filename, 'data:text/csv;charset=utf-8,%EF%BB%BF' + encodeURI(csvContent));
  };

  return (
    <TextButton
      onClick={handleDownload}
      style={{margin: 0, flexWrap: 'nowrap', whiteSpace: 'nowrap', gap: 10, display: 'flex', alignItems: 'center'}}>
      <DownloadIcon style={{display: 'inline', width: 20, verticalAlign: 'bottom'}} />
      {isSmallScreen ? <></> : buttonText}
    </TextButton>
  );
};
